import { render, staticRenderFns } from "./DataTableHolidays.vue?vue&type=template&id=5288e60a&scoped=true"
import script from "./DataTableHolidays.vue?vue&type=script&lang=js"
export * from "./DataTableHolidays.vue?vue&type=script&lang=js"
import style0 from "./DataTableHolidays.vue?vue&type=style&index=0&id=5288e60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288e60a",
  null
  
)

export default component.exports